import React, { Component, ErrorInfo, ReactNode } from 'react';
import styled from 'styled-components';
import { useTheme } from '../../contexts/ThemeContext';
import { Button } from '../../design-system/components/Button';
import { spacing } from '../../design-system/tokens/spacing';
import { typography } from '../../design-system/tokens/typography';
import { borders } from '../../design-system/tokens/borders';
import { animations } from '../../design-system/tokens/animations';
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: ${spacing[10]} ${spacing[5]};
  text-align: center;
`;
const Title = styled.h1`
  color: ${props => props.theme.colors.error};
  font-size: ${typography.fontSize['3xl']};
  font-weight: ${typography.fontWeight.bold};
  font-family: ${typography.fontFamily.display};
  margin-bottom: ${spacing[4]};
  letter-spacing: ${typography.letterSpacing.tighter};
`;
const Message = styled.p`
  color: ${props => props.theme.colors.textSecondary};
  font-size: ${typography.fontSize.base};
  font-family: ${typography.fontFamily.primary};
  margin-bottom: ${spacing[6]};
  line-height: ${typography.lineHeight.relaxed};
`;
interface Props {
  children: ReactNode;
}
interface State {
  hasError: boolean;
  error: Error | null;
}
export class ErrorBoundary extends Component<Props, State> {
  public state: State = { hasError: false, error: null };
  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }
  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }
  public render() {
    if (this.state.hasError) {
      return <ErrorFallback error={this.state.error} />;
    }
    return this.props.children;
  }
}
const ErrorFallback: React.FC<{ error: Error | null }> = ({ error }) => {
  const { colors } = useTheme();
  const handleReload = () => {
    window.location.reload();
  };
  return (
    <Container>
      {' '}
      <Title>Something went wrong</Title>{' '}
      <Message> {error?.message || 'An unexpected error occurred'} </Message>{' '}
      <Button onClick={handleReload}> Reload Page </Button>{' '}
    </Container>
  );
};
export default ErrorBoundary;
